import React from 'react';
import { Root, Scrim } from './ResultRankingScrim.styles';

export interface ResultRankingScrimProps {
  showScrim?: boolean;
}

/** dim 스크림 (프로모 배너는 스크롤로 노출) */
export function ResultRankingScrim({ showScrim = true }: ResultRankingScrimProps) {
  return (
    <Root aria-hidden="true">
      <Scrim $visible={showScrim} />
    </Root>
  );
}
